module.exports = __webpack_public_path__ + "static/media/logoBlanco.dfc76dfa.png";